module.exports = __webpack_public_path__ + "assets/img/btn-view-pedigree-chart-10b4b53d.png";